<template>
    <div>
        <!-- 检索条件 -->
        <div>
            <el-form :inline="true" @submit.native.prevent>
                <el-row>
                    <el-form-item :label="item.fieldShow + ':'" v-for="(item, index) in searchTermList" :key="index" v-show="item.isShow">
                        <el-input style="width:200px" v-if="item.fieldType == 'string' && item.isShow" clearable @change="((val) => { handleChange(val, item.fieldEntity) })" :placeholder="'请输入' + item.fieldShow" v-model.trim="item.value"
                            size="mini">
                        </el-input>
                        <el-date-picker v-else-if="item.fieldType == 'date' && item.isShow" @change="((val) => { handleChange(val, item.fieldEntity) })" size="mini" v-model="item.value" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                            type="date" placeholder="选择日期">
                        </el-date-picker>
                        <el-input style="width:200px" v-if="item.fieldType == 'number' && item.isShow" @change="((val) => { handleChange(val, item.fieldEntity) })" :placeholder="'请输入' + item.fieldShow" v-model.number="item.value"
                            size="mini">
                        </el-input>
                        <el-select size="mini" v-else-if="item.fieldType == 'formatter' && item.isShow" @change="((val) => { handleChange(val, item.fieldEntity) })" v-model="item.value" placeholder="请选择">
                            <el-option v-for="matItem in JSON.parse(item.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                        <el-button type="success" size="mini" @click="selectBtn" id="btn" v-if="isChoice">确定选择</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <!-- 表格 -->
        <el-table ref="moviesTable" height="420" size="mini" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange" @row-dblclick="handleSelectClick" style="width: 100%"
            :data="tableData" border>
            <el-table-column type="selection" width="50" v-if="isChoice">
            </el-table-column>
            <template v-for="(item, index) in Columns">
                <!-- 数字 -->
                <el-table-column v-if="item.isShow && (item.fieldType == 'formatter' || item.fieldType == 'date' || item.fieldType == 'string' || item.fieldType == 'number')" align="center" :key="index" :min-width="item.width || 80"
                    :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow" :show-overflow-tooltip="true">
                    <!-- 各种状态判断 -->
                    <template slot-scope="scope">
                        <el-tag v-if="item.fieldType == 'formatter'" size="mini" type="primary">{{ $common.getIsGsp(item.formatterContent, scope.row[item.fieldEntity]) }}</el-tag>
                        <span v-else-if="item.fieldType == 'date'">{{ $common.getLocalTime(scope.row[item.fieldEntity]) }}</span>
                        <span v-else-if="item.fieldType == 'string'">{{ scope.row[item.fieldEntity] }}</span>
                        <span v-else-if="item.fieldType == 'number'">{{ scope.row[item.fieldEntity] }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center" :key="index+1"
				:min-width="item.width || 80" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
					:show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center" :key="index+2"
				:min-width="item.width || 80" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
					:show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column v-else-if="item.fieldType == 'date' && item.isShow" align="center" :key="index+3"
				:min-width="item.width || 80" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
					:show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{$common.getLocalTime(scope.row[item.fieldEntity])}}</span>
					</template>
				</el-table-column> -->
            </template>
        </el-table>
        <!-- 分页 -->
        <el-pagination v-if="isPagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
</template>
<script>
export default {
    name: "SearchSchemeOther",
    components: {},
    data() {
        return {
            currentPage: 1,
            pageSizes: [10, 25, 50, 100],
            pageSize: 10,
            total: 0,
            tableData: [],
            isPagination: "",
            queryMap: {},
            searchTermList: [], //检索条件
            Columns: [],
            multipleSelection: [],
            selectedRow: [], // 当前已选择行
            selectedIndex: 0, // 当前选择行的index
            isChoice: false,//是否多选
        };
    },

    props: {
        id: {
            type: [Number, String],
            require: true,
        },
        cmId: {
            type: [Number, String],
            require: true,
        },
        ormId: {
            type: [Number, String],
            require: true,
        },
        coId: {
            type: [Number, String],
            require: true,
        },
        parentSearchData: {
            type: Object,
            require: false,
        },
        isRepetition: {
            type: Boolean,
            require: false,
        },
        isRepetitionList: {
            type: Array,
            require: false,
        },
        isProp: {
            type: [Number, String],
            require: false,
        },
        oneFlag: { //判断数据只剩一条是否默认填充 true:不填充不关闭 false:关闭填充
            type: Boolean,
            require: true,
            default: false
        },
    },
    watch: {},
    computed: {},
    mounted() {
        addEventListener('keyup', this.keyUp)
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    created() {
        let ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
        // 处理组件需要的数据
        this.$dbCache.Record_Get(this.id).then(async (val) => {
            let searchPlan = val
            if (!searchPlan) {
                searchPlan = await this.searchQuery();
            }
            let {
                pageCount, //分页条目
                isPagination, // 是否分页
                conditionList, // 检索条件
                tableList, // 表格头
                width, // 宽
                searchName, //title标题
                isChoice,//判断是否是多选  0否 1是
            } = searchPlan;
            this.isChoice = isChoice == 1 ? true : false
            conditionList.forEach((item) => {
                item.value = "";
                item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
                for (let key in this.parentSearchData) {
                    if (key == 'stId') {
                        this.queryMap[key] = this.parentSearchData[key]
                    }
                    if (item.fieldEntity == key) {
                        item.value = this.parentSearchData[key]
                    }
                }
            });

            tableList.forEach((item) => {
                item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
                item.isSort == 1 ? (item.isSort = true) : (item.isSort = false);
            });
            this.$emit("getWidth", width);
            this.$emit("sendTitle", searchName);
            this.pageSizes = pageCount.split(",").map(item => Number(item))
            this.Columns = tableList;
            this.searchTermList = conditionList;
            var day = 30
            if (JSON.parse(sessionStorage.getItem('printInfo')).days || JSON.parse(sessionStorage.getItem('printInfo')).days == 0) {
                day = JSON.parse(sessionStorage.getItem('printInfo')).days
            }
            this.searchTermList.forEach(item => {
                if (item.fieldEntity == 'start') {
                    item.value = new Date(new Date().toLocaleDateString()).getTime() - day * 24 * 3600 * 1000
                }
                if (item.fieldEntity == 'end') {
                  item.value = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
                }
            });
            this.isPagination = isPagination == 0 ? false : true; //是否分页
            // 根据返回数据处理一些页面逻辑
            this.pageSize = parseInt(this.pageSizes[0]);
            if (this.isPagination == true) {
                // 需要分页
                this.queryMap = {
                    searchPlanId: this.id,
                    page: this.currentPage,
                    rows: this.pageSize,
                };
                
                // 添加请求参数
                this.searchTermList.forEach((item) => {
                    this.queryMap[item.fieldEntity] = "";
                });
                if (this.queryMap.hasOwnProperty("ormId")) {
                    this.queryMap.ormId = ormId;
                }
                if (this.queryMap.hasOwnProperty("unitId")) {
                    if (this.parentSearchData.hasOwnProperty("smId") && this.parentSearchData.smId != '') {
                        this.queryMap.unitId = this.parentSearchData.smId;
                    }
                    if (this.parentSearchData.hasOwnProperty("cmId") && this.parentSearchData.cmId != '') {
                        this.queryMap.unitId = this.parentSearchData.cmId;
                    }
                }
                if (this.queryMap.hasOwnProperty("opmSalesperson")) {
                    this.queryMap.opmSalesperson = 1;
                }
                if (this.queryMap.hasOwnProperty("cmId")) {
                    this.queryMap.cmId = this.cmId;
                }
                if (this.queryMap.hasOwnProperty("coId")) {
                    this.queryMap.coId = this.coId;
                }
                for (let qkey in this.queryMap) {
                    for (let key in this.parentSearchData) {
                        if (key == 'stId') {
                            this.queryMap[key] = this.parentSearchData[key]
                        }
                        if (qkey == key) {
                            this.queryMap[qkey] = this.parentSearchData[key];
                        }
                    }
                }
            } else {
                this.queryMap = {
                    searchPlanId: this.id,
                };
                this.searchTermList.forEach((item) => {
                    this.queryMap[item.fieldEntity] = "";
                });
                if (this.queryMap.hasOwnProperty("ormId")) {
                    this.queryMap.ormId = ormId;
                }
                if (this.queryMap.hasOwnProperty("unitId")) {
                    if (this.parentSearchData.hasOwnProperty("smId") && this.parentSearchData.smId != '') {
                        this.queryMap.unitId = this.parentSearchData.smId;
                    }
                    if (this.parentSearchData.hasOwnProperty("cmId") && this.parentSearchData.cmId != '') {
                        this.queryMap.unitId = this.parentSearchData.cmId;
                    }
                }
                if (this.queryMap.hasOwnProperty("opmSalesperson")) {
                    this.queryMap.opmSalesperson = 1;
                }
                if (this.queryMap.hasOwnProperty("cmId")) {
                    this.queryMap.cmId = this.cmId;
                }
                if (this.queryMap.hasOwnProperty("coId")) {
                    this.queryMap.coId = this.coId;
                }
                for (let qkey in this.queryMap) {
                    for (let key in this.parentSearchData) {
                        if (key == 'stId') {
                            this.queryMap[key] = this.parentSearchData[key]
                        }
                        if (qkey == key) {
                            this.queryMap[qkey] = this.parentSearchData[key];
                        }
                    }
                }
            }
            for (let key in this.queryMap) {
                if (this.queryMap[key] == null || this.queryMap[key] == undefined) {
                    this.queryMap[key] = ''
                }
            }
            Object.keys(this.queryMap).forEach(key => {
                if (key == 'start') {
                    this.queryMap[key] = new Date(new Date().toLocaleDateString()).getTime() - day * 24 * 3600 * 1000
                }
                if (key == 'end') {
                    this.queryMap[key] = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
                }
            });
            this.getTableList(this.queryMap);

        });
    },
    methods: {
        async searchQuery() {
            const res = await this.$http.searchQuerySearchPlanById({ ids: [this.id] });
            if (res.status == 200) {
                return res.result;
            } else {
                this.$message.error(res.message);
                return {};
            }
        },
        keyUp(e) {
            if (this.isChoice) return;
            // 表格为空，不执行下方 
            if (this.tableData.length == 0) return

            if (e.keyCode == 40) { // 下键
                let refsElTable = this.$refs.moviesTable
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0
                    } else if (this.selectedIndex == this.tableData.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedIndex = 0
                    } else { // 正常递增
                        this.selectedIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.tableData[this.selectedIndex], false);
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                let refsElTable = this.$refs.moviesTable
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0
                    } else if (this.selectedIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedIndex = this.tableData.length - 1
                    } else { // 正常递减
                        this.selectedIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.tableData[this.selectedIndex], false);
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 13) {
                this.$emit("TranData", this.tableData[this.selectedIndex]);
            }

        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            if (this.isChoice) return;
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.color && row.color != '') {
                rowBackground.backgroundColor = row.color
            }
            if (this.isRepetition) {
                this.isRepetitionList.forEach(item => {
                    if (item[this.isProp] == row[this.isProp]) {
                        rowBackground.backgroundColor = "#dedede"
                    }
                })
            }
            return rowBackground
        },
        clickEvent(row, column, event, params) {
            if (this.isChoice) return;
            let refsElTable = this.$refs.moviesTable; // 获取表格对象
            let findRow = {}
            this.selectedIndex = row.rowIndex;
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        //多选
        selectBtn() {
            if (this.selectedRow.length == 0) {
                this.$message.warning('请勾选数据')
                return
            }
            this.$emit("TranData", this.selectedRow);
        },
        // 双击确认
        handleSelectClick(row, column, event) {

            this.$emit("TranData", row);
        },
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.queryMap[name] = value;
        },
        //   查询
        searchData() {
            this.currentPage = 1;
            this.queryMap.page = 1;
            this.getTableList(this.queryMap);
        },
        // 查询弹窗表格
        async getTableList(params) {
            if (params.cmId == '383900015104000') {
                params.orderType = ''
            }
            let res = await this.$http.querySearchPlanEntityVo(params);
            this.total = res.total;
            this.tableData = res.rows;
            // this.tableData.forEach(item=>{
            // 	item.bgColor = '#656565'
            // })
            if (this.tableData.length == 1 && this.total == 1 && !this.oneFlag) {
                this.$emit("TranData", this.tableData[0]);
                return
            }
            if (this.isChoice) return;
            this.$nextTick(() => {
                let refsElTable = this.$refs.moviesTable
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]);
            })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryMap.rows = val;
            this.getTableList(this.queryMap);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryMap.page = val;
            this.selectedIndex = 0
            this.getTableList(this.queryMap);
        },
        //   -----------------------------------------------------
        getHeaderCellStyle() {
            return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
        },
    },
};
</script>
<style scoped>
.el-pagination {
    padding: 20px 0px 5px;
}

::v-deep .el-table td div {
    font-weight: bold !important;
    font-size: 0.95rem !important;
    color: #333 !important;
}
</style>
<style>
.el-table .rowStyle {
    background: #33ccff !important;
}
</style>